import { Component, type ErrorInfo, type ReactNode } from 'react';

type BaseErrorBoundaryState = {
	hasError: boolean;
};

interface BaseErrorBoundaryProps {
	children: ReactNode;
	errorComponent?: JSX.Element;
	onError?: (error: Error, info?: ErrorInfo) => void;
}

// eslint-disable-next-line @repo/internal/react/no-class-components
export class BaseErrorBoundary extends Component<BaseErrorBoundaryProps, BaseErrorBoundaryState> {
	constructor(props: BaseErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	componentDidCatch(error: Error, info?: ErrorInfo): void {
		const { onError } = this.props;
		onError && onError(error, info);
		this.setState({ hasError: true });
	}

	render() {
		const { children, errorComponent } = this.props;
		const { hasError } = this.state;

		if (hasError && errorComponent) {
			return errorComponent;
		}

		return children;
	}
}
